(function () {
  'use strict';

  // Shared by Gift Guide Products (.ggp), Luxe Edit (.gle) and Categories (.ggc)
  var SECTION_SELECTOR = '.ggp, .gle, .ggc';
  var VAR_PREFIXES = ['--ggp-', '--gle-', '--ggc-'];

  function getVar(section, name, fallback) {
    var styles = getComputedStyle(section);
    for (var i = 0; i < VAR_PREFIXES.length; i++) {
      var value = styles.getPropertyValue(VAR_PREFIXES[i] + name);
      if (value) return parseFloat(value) || 0;
    }
    return fallback;
  }

  // Slider runs edge to edge; first/last card line up with the section gutter
  function getGutter(section) {
    return getVar(section, 'gutter', 0);
  }

  // Card gap comes from --*-card-gap in the section CSS, changes per breakpoint
  function getGap(section) {
    return getVar(section, 'card-gap', window.innerWidth >= 750 ? 20 : 12);
  }

  function initGiftGuideSwiper(section, attempts) {
    attempts = attempts || 0;

    var el = section.querySelector('[data-ggp-swiper]');
    if (!el || el.swiper) return;

    if (typeof Swiper === 'undefined') {
      // swiper-bundle.min.js is loaded async in theme.liquid, retry until ready (~5s)
      if (attempts > 50) return;
      window.setTimeout(function () {
        initGiftGuideSwiper(section, attempts + 1);
      }, 100);
      return;
    }

    var gutter = getGutter(section);

    var swiper = new Swiper(el, {
      // Slide widths come from --ggp-card-width in the section CSS
      slidesPerView: 'auto',
      spaceBetween: getGap(section),
      slidesOffsetBefore: gutter,
      slidesOffsetAfter: gutter,
      speed: 600,
      grabCursor: true,
      watchOverflow: true,
      threshold: 5,
      touchAngle: 30,
      touchStartPreventDefault: false,
      passiveListeners: true,
      navigation: {
        prevEl: section.querySelector('[data-ggp-arrow="prev"]'),
        nextEl: section.querySelector('[data-ggp-arrow="next"]')
      }
    });

    // Gutter and gap change per breakpoint, keep swiper in sync
    window.addEventListener('resize', function () {
      var nextGutter = getGutter(section);
      var nextGap = getGap(section);
      if (nextGutter === swiper.params.slidesOffsetBefore && nextGap === swiper.params.spaceBetween) return;
      swiper.params.slidesOffsetBefore = nextGutter;
      swiper.params.slidesOffsetAfter = nextGutter;
      swiper.params.spaceBetween = nextGap;
      swiper.update();
    });

    // Lazy images can change slide sizes after init
    window.addEventListener('load', function () {
      swiper.update();
    }, { once: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      initGiftGuideSwiper(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
